module.exports = __webpack_public_path__ + "img/logo-white.97521cd7.svg";